<template>

  <div id="examLogin" v-show="show">
    <exam-header ></exam-header>
    <el-row>
      <el-col :span="12"  :offset="6">
        <div class="exam-login" >
          <h3 class="center" style=" margin: 20px 0px 50px 0">监考验证</h3>
          <el-form ref="form" :model="user" label-width="100px" label-position="left" label-color="194793">
            <el-form-item label="监考人用户名" >
              <el-input v-model="user.invalidator"   v-validate="'required'" name="invalidator"></el-input>
            </el-form-item>
            <el-form-item label="监考人密码">
              <el-input v-model="user.invalidatorPwd" type="password" v-validate="'required'" name="invalidatorPwd"></el-input>
          </el-form-item >
          <div class="center" style=" margin-top: 50px;">
              <el-button type="primary" @click="check()" :class="{ blue_btn : user.invalidatorPwd!==''&& user.invalidator!=='', check_btn:true}" :disabled="user.invalidatorPwd==''|| user.invalidator==''" >验证</el-button>
          </div>
        </el-form>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import api from '@/modules/api.js'
import session from '@/components/cache'
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import examHeader from '@/layout/ExamHeader.vue'
import {showFullScreenLoading, tryHideFullScreenLoading} from '@/components/utils/loading.js'

// 提示语汉化
Validator.locale = 'zh_CN'
Vue.use(VeeValidate, {
  events: 'blur',
  fieldsBagName: 'fieldBags'
})
export default {
  name: 'examLogin',
  components: {examHeader},
  data () {
    return {
      user: {
        invalidatorPwd: '',
        invalidator: '',
        manageCom: session.session_get('manageCom')
      },
      state: '',
      canExam: '',
      valid: null,
      req: {
        businessNo: null
      },
      show: false
    }
  },
  watch: {
    state: function (newState, oldState) {
      console.log('监听')
      let that = this
      this.req.businessNo = session.session_get('businessNo')
      if (newState === 3) {
        console.log('考试失败')
        if(that.valid === 2){
            that.$router.push({name: 'examChooseTest', query: {}})
          }else{
            that.$router.push({name: 'examLogin', query: {}})
          }
        // todo... 验证冷却是否过时
        // if (that.valid === 2) {
          // api.post(this.$url.checkNextTime, this.req, function (res) {
          //   let state = res.data
          //   if (state === 3) {
          //     console.log('考试冷却已过')
          //     that.$router.push({name: 'examChooseTest', query: {}})
          //   }
          //   if (state === 4) {
          //     console.log('考试冷却未过')
          //     that.$router.push({name: 'examChooseTest', query: {}})
          //   }
          // })
        // }
      }

      if (this.state === 4) {
        console.log('未审核')
        api.post(this.$url.getInductState, this.req, function (res) {
          console.log(res)
          let state = res.data
          if (state === 0) {
            console.log('入司基本信息')
            that.$router.push({name: 'baseInfo', query: {}})
          }
          if (state === 1) {
            console.log('入司基本信息')
            that.$router.push({name: 'baseInfo', query: {}})
          }
          if (state === 2) {
            console.log('入司影像信息')
            that.$router.push({name: 'inCompanyImage', query: {}})
          }
          if (state === 3) {
            console.log('入司签署信息')
            that.$router.push({name: 'docSignList', query: {}})
          }
          if (state === 4) {
            console.log('入司验证信息')
            that.$router.push({name: 'verification', query: {}})
          }
          if (state === 5) {
            console.log('入司代理合同')
            that.$router.push({name: 'AgencyContract', query: {}})
          }
        })
      }
    }
  },
  methods: {
    check () {
      let that = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          showFullScreenLoading()
          api.invalidatorCheck(that.user, function (res) {
            if (res.result.isSuccess === true) {
              tryHideFullScreenLoading()
              session.session_set('businessNo', res.data)
              that.$router.push({name: 'examChooseTest'})
            } else {
              tryHideFullScreenLoading()
              that.$message.error(res.result.error)
            }
          })
        }
      })
    },
    getState () {
      let that = this
      api.post(this.$url.getExamState, {}, function (res) {
        if (res.result.isSuccess === true) {
          let state = res.data.state
          session.session_set('businessNo', res.data.businessNo)
          that.state = state
          that.user.manageCom = res.data.manageCom
          // if (that.valid === 2) {
            if (state === 0) {
              console.log('考试中')
              that.$router.push({name: 'Exam', query: {}})
            }
            if (state === 1) {
              console.log('未完成全部考试')
              that.$router.push({name: 'examChooseTest', query: {}})
            }
            if (state === 2) {
              console.log('考试成功')
              that.$router.push({name: 'ExamResult', query: {}})
            }
            if (state === 5) {
              console.log('审核中')
              that.$router.push({name: 'waitPage', query: {}})
            }
            if (state === 6) {
              console.log('审核通过')
              that.$router.push({name: 'index', query: {}})
            }
            if (state === 7) {
              console.log('审核不通过')
              that.$router.push({name: 'failPage', query: {}})
            }
          // }

          if (state === -1) {
            console.log('未考过')
            // that.show = true
            that.$router.push({name: 'examChooseTest', query: {}})
          }
          if (state === -2) {
            console.log('培训中')
            that.$router.push({name: '/home/index', query: {}})
          }
          if (state === -3) {
            console.log('非法')
            alert('用户不存在')
          }
          if (state === 9) {
            that.$router.push({path: '/home/index'})
          } else if (state === 8) {
            alert('欢迎加入大家庭')
            that.$router.push({path: '/home/index'})
          }
        } else {
          that.$toast(res.result.error)
        }
      })
    }
  },
  mounted () {
    let that = this
    api.post(this.$url.checkCanExam, {}, function (res) {
      that.canExam = res.data.state
      session.session_set('manageCom', res.data.manageCom)
      if (that.canExam === -1) {
        api.post(that.$url.checkLoginState, {}, function (res) {
          that.valid = res.data
          if (that.valid == 2) {
            that.show = false
            that.getState()
          } else {
            that.show = true
          }
        })
      }else if(that.canExam === -3){
        that.$alert('培训未通过', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          that.$router.push({path: '/'})
          }
        })
      }
    })
  }
}
</script>
<style lang="scss"  scoped>
.exam-login{
  border: solid 1px #D4DEE9;
  padding: 20px 50px 50px 50px;
  border-radius: 3%;
  background-color: #f8fbff;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 100px;
}
.center{
  text-align: center
}
.el-form-item__label{
  color:#194793
}
#examLogin .check_btn{
    background: #EBEBEB;
    color: #fff;
    width: 80%;
    border-color: #EBEBEB;
}
#examLogin .blue_btn{
    background: #194793;
     border-color: #194793;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examLogin.vue